export const componentNameConstants = {
  NTC_PAGE: "ntc_page",
  FPR_CREDIT_INSIGHTS: "fpr_credit_insights",
  FPR_SHORT_FORM_PRIMARY_CTA: "fpr_short_form_primary_cta",
  FPR_SHORT_FORM_SECONDARY_CTA: "fpr_short_form_secondary_cta",
  FPR_SHORT_FORM_CLOSE_CTA: "fpr_short_form_close_cta",
  FORM_SUBMIT_YES: "YES",
  FORM_SUBMIT_NO: "NO",
  FORM_SUBMIT_BUTTON: "form_submit_button",
  FORM_DROPDOWN: "form_dropdown",
  KEY_FEATURES: "key_features",
  FEATURES_AND_BENEFITS: "features_and_benefits",
  CIBIL_SCORE_METER: "cibil_score_meter",
  PRODUCT_CAROUSEL_BANNER: "Product Carousel Banner",
  SIGN_IN_WITH_DESCRIPTION: "sign_in_with_description",
  TITLE_LIST_CTA: "title_list_cta",
  VIDEO_PLAYED: "VIDEO_PLAYED",
  VIDEO_STARTED: "video_started",
  VIDEO_CAROUSEL: "video_carousel",
  CAMPAIGN_HEADER: "campaign_header",
  //
  ARTICLES_CAROUSEL: "articles_carousel",
  ARTICLES_AND_INSIGHTS: "articles-and-insights",
  ICON_CLICK: "icon_click",
  SCRIP_OVERVIEW: "scrip_overview",
  BREADCRUMB: "breadcrumb",
  FAQ: "faq",
  // ✅ Existing
  STOCK_MODAL: "stock_modal",
  STOCK_FUNDAMENTALS: "stock_fundamentals",
  SCRIP_FINANCIALS: "scrip_financials", // Info Icon click tracking
  STOCK_PERFORMANCE: "stock_performance", // ✅ Added for Stock Performance section
  MARKET_SECURITIES: "market_securities",
  FOOTER_COMPONENT: "footer",
  HeaderSignIn: "HeaderSignIn",
  HEADER_NOTIFICATION: "header_notification",
  TRENDING_OFFERS: "TRENDING_OFFERS",
  TOP_NAVIGATION_BAR_HEADER: "top_navigation_bar_header",
  SEARCH_BAR: "search_bar",
  BOTTOM_NAVIGATION: "bottom_navigation",

  // ✅ Newly added
  SUBSCRIPTION_CARD_CAROUSEL: "subscription_card_carousel",
  STOCK_LIST_CARD: "stock_list_card",

  // ✅ Trading Mall components
  STOCK_INFO: "stock_info",
  SIMILAR_STOCKS: "similar_stocks",
  OPEN_DEMAT_BUTTON: "open_demat_button",
  TECHNICAL_SUMMARY: "technical_summary",
  SHAREHOLDING_PATTERN: "shareholding_pattern",
  STOCK_PERFORMANCE_GRAPH: "stock_performance_graph",

  //B2B Clp components
  LOCATOR_TILES: "locator_tiles",
  LISTING_TILES_WITH_SCROLL: "listing-tiles-with-scroll",
  LOCATION_STRIP: "location_strip",
  MOST_VIEWED_PRODUCTS: "most_viewed_products",
  TOP_DEALS: "top_deals",
  EXPLORE_BUYING_GUIDES: "explore_buying_guides",
  RECOMMENDED_PRODUCTS: "recommended_products",
  VIEWONLINEBUYOFFLINE: "view_online_buy_offline",
  BLOCKBUSTERFRIDAY: "BlockBusterFriday",
  NEWLAUNCHPRODUCTS: "bm_new_launch_component",
  TITLE_OFFER_BANNER: "title_offer_banner",
  // ✅ StoryBlock and VideoGrid specific elements
  LIVE_COMMERCE_PAGE_CLICKED: "LIVE_COMMERCE_PAGE_CLICKED",
  LIVE_COMMERCE_PAGE_VIEWED: "LIVE_COMMERCE_PAGE_VIEWED",
  LIVE_COMMERCE_CLP: "LIVE_COMMERCE_CLP",
  PAGE_NAME: "PIP_VIDEO_PLAY",
  LIVE_COMMERCE: "LIVE_COMMERCE",
  LIVE_SESSIONS: "LIVE_SESSIONS",
  VIDEO_VIEWED: "VIDEO_VIEWED",
  VIDEO_CLICKED: "VIDEO_CLICKED",
  EP_EVENT_TYPE: "view",
  // ✅ StoryBlock component
  STORY_BLOCK: "STORY_BLOCK",
  VIDEO_GRID: "video_grid",
  UPCOMING_LIVE: "upcoming_live",
  FORM_WIDGET: "form_widget",
  BANNER_CAROUSEL: "banner_carousel",
};

export const dlElementConstants = {
  KEY_FEATURE_ACCORDION_OPENED: "KEY_FEATURE_ACCORDION_OPENED",
  EP_EXPERIAN_PAGE_NAME: "EXPERIAN PAGE",
  SYSTEM_ERROR_PAGE: "SYSTEM_ERROR_PAGE",
  VALID_ERROR_PAGE: "VALID_ERROR_PAGE",
  CIBIL_SCORE_METER_SUBS_EXPIRED_OLD_REPORT: "cibil_score_meter_subscription_expired_report_button",
  CIBIL_SCORE_METER_DOWNLOAD_REPORT_BUTTON: "cibil_score_meter_download_report_button",
  FPR_CREDIT_INSIGHTS_DROPDOWN: "fpr_credit_insights_dropdown",
  FPR_SHORT_FORM_PRIMARY_CTA_CLICK: "fpr_short_form_primary_cta_click",
  FPR_SHORT_FORM_SECONDARY_CTA_CLICK: "fpr_short_form_secondary_cta_click",
  FPR_SHORT_FORM_CLOSE_CLICK: "fpr_short_form_close_click",
  FPR_EXIT_MODAL_EXIT_CTA_CLICK: "exit_modal_exit_cta_click",
  FPR_EXIT_MODAL_STAY_CTA_CLICK: "exit_modal_stay_cta_click",
  CAMPAIGN_HEADER_FEEDBACK_MODAL_CHECKBOX: "feedback_checkbox",
  CAMPAIGN_HEADER_FEEDBACK_MODAL_CLS_BUTTON: "feedback_modal_close_button",
  FORM_SUBMIT_BUTTON_CLICK: "form_submit_button_click",
  FORM_DROPDOWN_SELECTION: "form_dropdown_selection",
  KEY_FEATURES_LINK_CLICK: "key_features_link_click",
  KEY_FEATURES_ACCORDION_DROPDOWN: "key_features_accordion_dropdown",
  FEATURE_CARD: "feature_card",
  CIBIL_SCORE_METER_NTC_KNOW_WHY_BUTTON: "cibil_score_meter_ntc_know_why_button",
  VIDEO_CLICK: "video_click",
  IMAGE_CLICK: "image_click",
  PRODUCT_CAROUSEL_BANNER_IMAGE_VIDEO_CLICK: "product_banner_slide_click",
  SIGN_IN_WITH_DESCRIPTION_LINK_CLICK: "sign_in_with_description_link_click",
  TITLE_LIST_CTA_BUTTON_CLICK: "title_list_cta_button_click",
  CAROUSEL_ARROW_PREV_ICON: "carousel_arrow_prev_icon",
  CAROUSEL_ARROW_NEXT_ICON: "carousel_arrow_next_icon",
  CAMPAIGN_HEADER_ACTIVE_TITLE: "campaign_header",
  CAMPAIGN_HEADER_BACK_BUTTON: "campaign_header_back_button",
  WISHLIST_CARD_CAROUSEL_ARROW: "wishlist_card_carousel_arrow",
  ARTICLES_CAROUSEL_LINK_CLICK: "articles_carousel_link_click",
  ARTICLE_LIST_READ_MORE: "article_list_read_more",
  ARTICLE_LIST_CARDS: "wishlist_card_carousel_arrow",
  SCRIP_OVERVIEW_READ_MORE: "scrip_overview_read_more",
  FAQ_DROPDOWN: "faq_dropdown",
  // ✅ Existing elements
  SCRIP_OVERVIEW_BTN_CLICK: "scrip_overview_button_close",
  SCRIP_OVERVIEW_ICON_CLICK: "scrip_overview_icon_close",
  BREADCRUMB_LINK_CLICK: "breadcrumb_link_click",
  TRADING_MALL_STOCK_PLP: "TRADING MALL STOCK PLP",
  MARKET_SECURITIES_BTN_CLICK: "market_securities_button_click",
  // ✅ Newly added elements for Stock Fundamentals and Performance DL tracking
  OPEN_ICON: "open_icon",
  INFO_ICON: "info_icon",
  PDP_CLICKED: "TRADINGMALL_DETAILS_SUBMITTED",
  FUNDAMENTALS: "fundamentals",
  FINANCIALS: "financials",
  STOCK_FUNDAMENTALS_BTN_CLICK: "stock_fundamentals_button_close",
  STOCK_FUNDAMENTALS_ICON_CLICK: "stock_fundamentals_icon_close",
  SCRIP_FINANCIALS_BTN_CLICK: "scrip_financials_button_click",
  SCRIP_FINANCIALS_ICON_CLICK: "scrip_financials_icon_click",
  SCRIP_FINANCIALS_TAB_CLICK: "scrip_financials_tab_click",
  TRADING_MALL_STOCK_PDP: "TRADING MALL STOCK PDP",
  STOCKS: "STOCK",
  TAB_CLICK: "tab_click",
  // ✅ Newly added for Stock Performance
  STOCK_PERFORMANCE: "stock_performance",

  // ✅ Newly added for Subscription Card Carousel
  SUBSCRIPTION_CARD_CAROUSEL_CTA: "subscription_card_carousel_cta",

  // ✅ Trading Mall specific elements
  OPEN_DEMAT_BUTTON: "Open_Demat_Button",
  OPEN_DEMAT_BUTTON_SUBMIT: "open_demat_button_submit",
  CLOSE_ICON: "close_icon",
  SIMILAR_STOCKS_CARD_CLICK: "similar_stocks_card_click",
  TECHNICAL_SUMMARY_TAB_CLICK: "technical_summary_tab_click",
  SHAREHOLDING_PATTERN_TAB_CLICK: "shareholding_pattern_tab_click",
  SHAREHOLDING_PATTERN_BUTTON_CLICK: "shareholding_pattern_button_click",
  STOCK_LIST_VIEW_ALL_CLICK: "Stock_list_view_all_click",
  STOCK_PERFORMANCE_GRAPH_DURATION_BTN: "stock_performance_graph_duration_btn",
  NOTIFICATION_DELETE_ICON: "notification_delete_icon",
  NOTIFICATION_BELL_ICON: "notification_bell_icon",
  FOOTER_GO_TO_TOP: "footer_go_to_top",
  TRENDING_OFFERS_MODAL_BUTTON_CTA: "TRENDING_OFFERS_MODAL_BUTTON_CTA",
  BANNER_CAROUSEL_CTA: "banner_carousel_cta",

  // B2B Clp elements
  LOCATOR_TILES_SHOW_MORE_CTA: "locator_tiles_show_more_cta",
  LOCATOR_TILES_SHOW_LESS_CTA: "locator_tiles_show_less_cta",
  LOCATOR_TILES_CARD: "locator_tiles_card",
  LISTING_ICONS_CARDS: "listing_icons_cards",
  LISTING_ICONS_VIEWALL_CTA: "listing_icons_viewall_cta",
  LISTING_ICONS_CAROUSEL_ARROW: "listing_icons_carousel_arrow",
  FILTER_TAB_CLICK: "filter_tab_click",
  RECOMMENDED_PRODUCTS_CARD_CLICK: "recommended_products_card_click",
  FAQ_LINK_CLICK: "faq_link_click",
  NEW_LAUNCH_PRODUCTS_CARD_CLICK: "bm_new_launch_components_card_click",
  SWIPER_ARROW_CLICK: "swiper_arrow_click",
  OFFER_BANNER_BTN_CLICK: "offer_banner_button_click",
  PRODUCT_CARD: "product_card",
  SHOW_MORE_CTA: "show_more_cta",
  SHOW_LESS_CTA: "show_less_cta",
  // Electronics On EMI specific elements
  INPUT_TEXT: "input_text",
  SEARCH_RESULT: "Search Result",
  CLEAR_RESULTS_CTA_CLICK: "clear_results_cta_click",
  PRODUCT_CARD_CLICK: "product_card_click",
  // ✅ StoryBlock and VideoGrid specific elements
  LIVE_COMMERCE_PAGE_CLICKED: "LIVE_COMMERCE_PAGE_CLICKED",
  LIVE_COMMERCE_PAGE_VIEWED: "LIVE_COMMERCE_PAGE_VIEWED",
  LIVE_COMMERCE_CLP: "LIVE_COMMERCE_CLP",
  PAGE_NAME: "PIP_VIDEO_PLAY",
  LIVE_COMMERCE: "LIVE_COMMERCE",
  LIVE_SESSIONS: "LIVE_SESSIONS",
  VIDEO_VIEWED: "VIDEO_VIEWED",
  VIDEO_CLICKED: "VIDEO_CLICKED",
  EP_EVENT_TYPE: "view",
  FORM_WIDGET_CTA_CLICK: "form_widget_cta_click",
};

export enum dlEventConstants {
  DROP_DOWN_SELECTION = "DROP_DOWN_SELECTION",
  CHECKBOX_CLICK = "checkbox_click",
  CAROUSAL_PAGINATION_CLICK = "carousel_pagination_click",
  CAROUSEL_PAGINATION_DOT = "carousel_pagination_dot",
  PAGINATION_CLICK = "pagination_click",
  IMAGE_CLICK = "image_click",
  VIDEO_CLICK = "video_click",
  CLICK = "click",
  BUTTON_CLICK = "button_click",
  OPTION_SELECTION = "option_selection",
  SELECTION_CLICK = "selection_click",
  TAB_CLICK = "tab_click",
  // ✅ Newly added event types
  ICON_CLICK = "icon_click",
  LINK_CLICK = "link_click",
  CARD_ICON = "card_icon",
  CLOSE = "CLOSE",
  HEADER_CLICK = "header_click",
  CARD_CLICK = "card_click",
  TEXT_CLICK = "text_click",
  // ✅ StoryBlock event types
  KNOW_MORE = "KNOW_MORE",
  VIDEO_PLAY = "VIDEO_PLAY",
  PRODUCT_CTA = "PRODUCT_CTA",
  CLICK_CTA = "CLICK_CTA",
  THUMBNAIL_CLICK = "THUMBNAIL_CLICK",
  QUIT = "quit",
  BANNER_CLICK = "banner_click",
  BACK_BUTTON = "BACK",
  DEVICE_BACK = "DEVICE_BACK",
}

export const dlCtaTextConstants = {
  ARROW_ICON: "arrow_icon",
  CLOSE_ICON: "close_icon",

  // ✅ Newly added CTA text
  READ_MORE: "read_more",
  SUBSCRIBE_NOW: "subscribe_now",
  LEFT_ARROW: "LEFT_ARROW",
  RIGHT_ARROW: "RIGHT_ARROW",
};

// ✅ Trading Mall section titles
export const dlSectionTitleConstants = {
  OPEN_DEMAT_ACCOUNT: "Open Demat Account",
  SIMILAR_STOCKS: "Similar Stocks",
  STOCK_FINANCIALS: "Stock Financials",
  TECHNICAL_SUMMARY: "Technical Summary",
  SHAREHOLDING_PATTERN: "Shareholding Pattern",
  STOCK_PERFORMANCE: "Stock Performance",
  STOCK_LIST: "Stock List",
};

// ✅ CleverTap event names
export const cleverTapEventNames = {
  CAROUSEL_ARROW_PREV_ICON: "carousel_arrow_prev_icon",
  CAROUSEL_ARROW_NEXT_ICON: "carousel_arrow_next_icon",
  SIMILAR_STOCKS_CARD_CLICK: "similar_stocks_card_click",
};

// ✅ CleverTap journey names
export const cleverTapJourneyNames = {
  TRADING_MALL_STOCK_PDP: "TRADING MALL STOCK PDP",
  TRADING_MALL_STOCK_PLP: "TRADING MALL STOCK PLP",
};

// ✅ CleverTap article names
export const cleverTapArticleNames = {
  FINANCIALS: "FINANCIALS",
  TECHNICAL_SUMMARY: "TECHNICAL SUMMARY",
  SHAREHOLDING_PATTERN: "SHAREHOLDING PATTERN",
};

// ✅ Header analytics constants
export const headerConstants = {
  // Element constants
  ELEMENTS: {
    NOTIFICATION_CLOSE_ICON: "notification_close_icon",
    HEADER_SIGN_IN_ICON: "Header sign in icon",
    HEADER_EMI_ICON: "header_emi_icon",
    HEADER_CART_ICON: "Header Cart icon",
    HEADER_REWARDS_ICON: "Header Rewards icon",
    HEADER_PARTNER_ICON: "Header Partner icon",
    TOP_NAVIGATION_SIDEBAR: "top_navigation_sidebar",
    SEARCH_BACK_ICON: "back icon",
    SEARCH_ICON: "search icon",
    SEARCH_SUGGESTION: "search suggestion",
    CROSS_ICON: "cross icon",
  },

  // Component constants
  COMPONENTS: {
    HEADER: "header",
    HEADER_CART: "HeaderCart",
    HEADER_REWARD: "HeaderReward",
    HEADER_PARTNER: "HeaderPartner",
    TOP_NAVIGATION: "top_navigation",
    SEARCH_BANNER: "search_banner",
    SEARCH_BAR: "search_bar",
    SEARCH_RESULT_PAGE: "search_result_page",
  },

  // Event name constants
  EVENT_NAMES: {
    NOTIFICATION_DELETE_ICON: "NOTIFICATION_DELETE_ICON",
    NOTIFICATION_BELL_ICON: "NOTIFICATION_BELL_ICON",
    NOTIFICATION_CLOSE_ICON: "NOTIFICATION_CLOSE_ICON",
    HEADER_SIGN_IN_CLICK: "HEADER_SIGN_IN_CLICK",
    HEADER_EMI_CLICK: "HEADER_EMI_CLICK",
    HEADER_CART_CLICK: "HEADER_CART_CLICK",
    HEADER_REWARDS_CLICK: "HEADER_REWARDS_CLICK",
    HEADER_PARTNER_CLICK: "HEADER_PARTNER_CLICK",
    HEADER_MENU_CLICK: "HEADER_MENU_CLICK",
    HEADER_MENU_CLOSE_CLICK: "HEADER_MENU_CLOSE_CLICK",
    HEADER_MAIN_MENU_CLICK: "HEADER_MAIN_MENU_CLICK",
    HEADER_SIDEBAR_PROFILE_CLICK: "HEADER_SIDEBAR_PROFILE_CLICK",
    HEADER_SIDEBAR_MENU_BUTTON_CLICK: "HEADER_SIDEBAR_MENU_BUTTON_CLICK",
    SEARCH_BACK_CLICK: "SEARCH_BACK_CLICK",
    SEARCH_SUBMIT: "SEARCH_SUBMIT",
    SEARCH_SUGGESTION_CLICK: "SEARCH_SUGGESTION_CLICK",
    SEARCH_HISTORY_DELETE: "SEARCH_HISTORY_DELETE",
    TOP_NAVIGATION_BAR_HEADER_ICON_CLICK: "top_navigation_bar_header_icon_click",
    SEARCH_BAR_ICON_CLICK: "search_bar_icon_click",
    SEARCH_BAR_TAB_CLICK: "search_bar_tab_click",
    BOTTOM_NAVIGATION_ICON_CLICK: "bottom_navigation_icon_click",
    BOTTOM_NAVIGATION_BACK_CLICK: "bottom_navigation_back_click",
    FOOTER_ICON_CLICK: "footer_icon_click",
    FOOTER_LINK_CLICK: "footer_link_click",
    FOOTER_DOWNLOAD_ICON_CLICK: "footer_download_icon_click",
  },

  // Section title constants
  SECTION_TITLES: {
    HEADER: "Header",
    HEADER_CART: "Header Cart icon",
    SEARCH: "Search",
    SEARCH_HISTORY: "Search History",
    SEARCH_RESULT: "Search Result",
  },

  // CTA text constants
  CTA_TEXT: {
    NOTIFICATION_CLOSE: "Notification close icon",
    HEADER_SIGN_IN: "Header sign in icon",
    EMI_CARD: "emi_card",
    HEADER_CART: "Header Cart icon",
    PRIME: "Prime",
    PARTNERS: "Partners",
    MENU: "Menu",
    CLOSE_MENU: "Close Menu",
  },

  // Search specific constants
  SEARCH: {
    EVENT_CLICK: {
      ICON_CLICK: "icon_click",
      INPUT_TEXT: "input_text",
      OPTION_SELECTION: "option_selection",
    },
    TARGET: {
      SEARCH_RESULT_REMOVE_OPTION: "search_result_remove_option",
      SEARCH_BANNER_DIRECTION_ICON: "search_banner_direction_icon",
      SEARCH_BAR_INITIATION: "search_bar_initiation",
      SEARCH_BANNER_OPTION_SELECTION: "search_banner_option_selection",
    },
    SUB_SECTION: {
      CROSS_ICON: "cross icon",
    },
  },

  // Mobile Navigation specific constants
  MOBILE_NAVIGATION: {
    ELEMENTS: {
      BOTTOM_NAVIGATION_ICONS: "bottom-navigation-icons",
      BOTTOM_NAVIGATION_MENU: "bottom-navigation-menu",
    },
    COMPONENTS: {
      BOTTOM_NAVIGATION_MOBILE: "bottomNavigationMobile",
    },
    EVENT_TYPES: {
      CARD_CLICK: "card_click",
      ICON_CLICK: "icon_click",
      LINK_CLICK: "link_click",
      SOCIAL_ICON_CLICK: "SOCIAL_ICON_CLICK",
    },
    EVENT_NAMES: {
      BOTTOM_NAV_MENU_CLICK: "BOTTOM_NAV_MENU_CLICK",
      BOTTOM_NAV_ICON_CLICK: "BOTTOM_NAV_ICON_CLICK",
      HAMBURGER_MENU_CLOSE_CLICK: "HAMBURGER_MENU_CLOSE_CLICK",
      HAMBURGER_MENU_CARD_CLICK: "HAMBURGER_MENU_CARD_CLICK",
      CROSS_SELL_LINK_CLICK: "CROSS_SELL_LINK_CLICK",
      HAMBURGER_MENU_LINK_CLICK: "HAMBURGER_MENU_LINK_CLICK",
      SOCIAL_MEDIA_ICON_CLICK: "SOCIAL_MEDIA_ICON_CLICK",
    },
    CTA_TEXT: {
      MENU: "Menu",
      BOTTOM_NAVIGATION_ICONS: "bottom-navigation-icons",
    },
  },
};
